import PropTypes from "prop-types";
import { PlaceShape, SpaceMinShape } from "./index";

const DataShape = PropTypes.shape({
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  spaces: PropTypes.arrayOf(SpaceMinShape).isRequired,
  all: PropTypes.number.isRequired,
  sort_by: PropTypes.string.isRequired,
  place_model: PlaceShape.isRequired,
  seo: PropTypes.shape({
    header: PropTypes.string.isRequired,
  }).isRequired,
});

export default DataShape;
